import React, {useState} from 'react';

import {Button, CreateIcon} from '@kit';

import {useCharacter} from '../character-context';
import {MAX_CHARACTER_LEVEL} from '../model/character-state';
import {multiclassBlockers} from '../model/multiclass';
import {ClassList} from './class-list';
import {ClassSection} from './class-section';

export const ClassStep: React.FC = () => {
	const {catalog, state, features, character, update} = useCharacter();
	const [isAddingClass, setAddingClass] = useState(false);
	const hasClasses = state.classes.length > 0;

	const addClass = (classId: string) => {
		update((current) => ({classes: [...current.classes, {classId, level: 1}]}));
		setAddingClass(false);
	};

	const availableClasses = catalog.classes.filter(
		(classData) => !state.classes.some((classLevel) => classLevel.classId === classData.id),
	);

	return (
		<>
			{!hasClasses || isAddingClass ? (
				<>
					<p>{hasClasses ? 'Выберите класс для мультиклассирования:' : 'Выберите стартовый класс:'}</p>
					<ClassList
						classes={availableClasses}
						onSelect={addClass}
						blockers={
							hasClasses ? (classData) => multiclassBlockers(catalog, character, classData) : undefined
						}
					/>
					{isAddingClass && (
						<Button appearance="subtle" onClick={() => setAddingClass(false)}>
							Отмена
						</Button>
					)}
				</>
			) : (
				<>
					<p>Ваш персонаж {character.level}-го уровня.</p>
					{features.classes.map((classFeatures) => (
						<ClassSection key={classFeatures.classData.id} classFeatures={classFeatures} />
					))}
					{character.level < MAX_CHARACTER_LEVEL && availableClasses.length > 0 && (
						<Button icon={<CreateIcon />} onClick={() => setAddingClass(true)}>
							Добавить класс
						</Button>
					)}
				</>
			)}
		</>
	);
};
